<template>
  <section  v-bind:class="{ 'narrowed': searchFormNarrowed }" role="search">
    <form id="search-form">
      <search-box v-on:search-by-fields="$emit('search-by-fields')"></search-box>
    </form>
  </section>
</template>

<script>
import SearchBox from '@/components/SearchBox'

export default {
  name: 'search-form',
  components: {
    SearchBox
  },
  computed: {
    searchFormNarrowed: function() {
      // Only collapse the search form if we're on the home page. Otherwise, 
      // it will be collapsed too narrow if other page elements have made
      // this control small already
      return this.$route.meta.resizeSearch
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/app.scss';
.search-form {
  $tablet-margin: 5.0em;
  $desktop-margin: 10.0em;
  background-color: white;
  border: 1px solid lightgrey;
  border-radius: 5px;
  transition: margin-left 0.5s;
  padding: 0.4em;
  margin: 0 0.5em 0.5em 0.5em;
  label {
    font-size: 0.95em;
  }
}

</style>
